import { pwaInstallService } from "./PwaInstallService.js";
//#region src/pwa/PwaInstallController.ts
var PwaInstallController = class {
	constructor(host) {
		this._host = host;
		host.addController(this);
	}
	/** True when a native install prompt is available. */
	get canInstall() {
		return pwaInstallService.canInstall;
	}
	/** True once installed (this session) or running standalone. */
	get installed() {
		return pwaInstallService.installed;
	}
	/** True when the browser has an install-prompt concept at all (Chromium). */
	get isSupported() {
		return pwaInstallService.isSupported;
	}
	/** True when running in a standalone/installed display mode. */
	get isStandalone() {
		return pwaInstallService.isStandalone;
	}
	/** True on iOS Safari, where installation is manual (Share sheet). */
	get isIOS() {
		return pwaInstallService.isIOS;
	}
	/** How the app can be installed in the current context. */
	get platform() {
		return pwaInstallService.platform;
	}
	/**
	* Trigger the native install prompt.
	* @returns The user's choice, or `"unavailable"` when no prompt exists.
	*/
	install() {
		return pwaInstallService.promptInstall();
	}
	hostConnected() {
		this._unsubscribe = pwaInstallService.subscribe(() => {
			this._host.requestUpdate();
		});
	}
	hostDisconnected() {
		this._unsubscribe?.();
	}
};
//#endregion
export { PwaInstallController };
